/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OofBelt } from './oofBelt';
import { ProximityConfiguration } from './proximityConfiguration';
import { OofDropOffConfigurationDto } from './oofDropOffConfigurationDto';
import { IotConfig } from './iotConfig';
import { ScheduleFileDtoString } from './scheduleFileDtoString';
import { MagnetometerConfig } from './magnetometerConfig';
import { ScheduleFileDtoListString } from './scheduleFileDtoListString';


export interface OrderItemConfigurationFormData { 
    accAdvancedSensorPackage?: boolean;
    accSampleRate?: string;
    accSensorRange?: string;
    animalSpecies?: string;
    batteryShape?: OrderItemConfigurationFormData.BatteryShapeEnum;
    batterySize?: OrderItemConfigurationFormData.BatterySizeEnum;
    batteryWithDropOff?: boolean;
    belt?: OofBelt;
    beltColorDE?: string;
    collarImage?: string;
    communicationSchedule?: ScheduleFileDtoString;
    context?: { [key: string]: any; };
    customerName?: string;
    dataPlan?: OrderItemConfigurationFormData.DataPlanEnum;
    deviceComment?: string;
    emailNotifications?: Array<string>;
    externalDropOff?: OofDropOffConfigurationDto;
    fixedAssignmentVhfFrequenciesDescription?: string;
    globalstarChannel?: string;
    globalstarMode?: number;
    globalstarOperationCountry?: string;
    gpsSchedule?: ScheduleFileDtoString;
    gpsSkipCount?: number;
    gsmDestinationNumber?: string;
    gsmMode?: number;
    hibernationMode?: boolean;
    hibernationPeriod?: number;
    hibernationWakeupLevel?: number;
    housingLabel?: string;
    idTag?: boolean;
    internalDropOff?: OofDropOffConfigurationDto;
    inventaDataManagers?: Array<string>;
    inventaDeviceManagers?: Array<string>;
    inventaOwner?: string;
    iot?: IotConfig;
    iotMode?: number;
    iridiumMode?: number;
    isBatteryFix?: boolean;
    kmlFile?: string;
    lateralMortality?: boolean;
    magnetometer?: MagnetometerConfig;
    mortalityMode?: boolean;
    mortalityPeriod?: number;
    ownIridiumProvider?: boolean;
    plannedDeploymentDate?: string;
    prioListNo?: number;
    productionRecordComment?: string;
    proximity?: ProximityConfiguration;
    requestedDeliveryDate?: string;
    shouldUnsubscribeIridiumPlan?: boolean;
    smsNotifications?: Array<string>;
    specialRequest?: string;
    uhfCommunication?: string;
    utcCorrection?: number;
    vhfBeaconFrequencies?: string;
    vhfSchedule?: ScheduleFileDtoListString;
    virtualFenceMode?: string;
    virtualFenceSchedule?: ScheduleFileDtoString;
}
export namespace OrderItemConfigurationFormData {
    export const BatteryShapeEnum = {
        Square: 'SQUARE',
        Curved: 'CURVED'
    } as const;
    export type BatteryShapeEnum = typeof BatteryShapeEnum[keyof typeof BatteryShapeEnum];
    export const BatterySizeEnum = {
        _1C: '1C',
        _1D: '1D',
        _2D: '2D',
        _3D: '3D',
        _4D: '4D',
        _5D: '5D',
        _6D: '6D',
        _7D: '7D',
        _15D: '15D',
        _26C: '26C',
        _1A: '1A',
        _1Aa: '1AA',
        _25Aa: '2.5AA',
        _05Aa: '0.5AA',
        Lp14: 'LP14',
        Mp25: 'MP25',
        _2Sx: '2SX'
    } as const;
    export type BatterySizeEnum = typeof BatterySizeEnum[keyof typeof BatterySizeEnum];
    export const DataPlanEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanEnum = typeof DataPlanEnum[keyof typeof DataPlanEnum];
}


export type DataPlanEnum = typeof OrderItemConfigurationFormData.DataPlanEnum[keyof typeof OrderItemConfigurationFormData.DataPlanEnum];
